import { useState } from "react";
import api from "../../services/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");

  async function submit(e) {
    e.preventDefault();
    await api.post("/request_password_reset.php", { email });
    setMsg("Se o email existir, enviaremos um link para redefinição.");
  }

  return (
    <div className="min-h-screen bg-[#0b0f19] flex items-center justify-center">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-[#1f2937] bg-[#121826] p-6">
        <h1 className="text-xl font-semibold text-slate-100">Recuperar senha</h1>
        {msg && <p className="mt-4 text-sm text-green-400">{msg}</p>}
        <input
          type="email" required placeholder="Seu email"
          value={email} onChange={e=>setEmail(e.target.value)}
          className="mt-6 w-full rounded-xl border border-[#1f2937] bg-[#0b0f19] px-4 py-3 text-slate-100"
        />
        <button className="mt-6 w-full rounded-xl bg-blue-600 py-3 text-sm font-semibold hover:bg-blue-500">
          Enviar link
        </button>
      </form>
    </div>
  );
}
